import { type AxiosInstance } from "axios";
import type {
  BulkAcquisitionRequest,
  BulkAcquisitionResponse,
} from "@/features/propertyCodeBulkAcquisition/types";

// 一括依頼 API の呼び出し層。エラー分岐（403/409 等）の UI は呼び出し側で行う

/** 一括依頼エンドポイント。POST /api/property-codes/picture-requests/bulk（baseURL が /api を付与）。 */
export const BULK_PICTURE_REQUEST_ENDPOINT =
  "/property-codes/picture-requests/bulk";

/**
 * 選択物件の一括取得依頼を送信する。成功（201）で pictureRequestId が返る。
 * エラーは throw し、HTTP ステータスによる判定は呼び出し側で行う。
 * @param apiClient JWT 認証付き apiClient
 * @param request 依頼内容（識別名・取得方式・明細）
 */
export const postBulkPictureRequest = async (
  apiClient: AxiosInstance,
  request: BulkAcquisitionRequest
): Promise<BulkAcquisitionResponse> => {
  const { data } = await apiClient.post<BulkAcquisitionResponse>(
    BULK_PICTURE_REQUEST_ENDPOINT,
    request
  );
  return data;
};
